import Pusher from 'pusher-js';
import { Observable, shareReplay, switchMap } from 'rxjs';
import { PUSHER_CLUSTER, PUSHER_CLIENT_KEY } from 'config/environment';
import { ApiKey } from 'services';
import { authorizer } from './authorizer';
import { recordMainThreadConnection } from './telemetry';
const pusher$ = ApiKey.tokens().pipe(switchMap(()=>new Observable((subscriber)=>{
        const pusher = new Pusher(PUSHER_CLIENT_KEY, {
            auth: {
                headers: ApiKey.header()
            },
            cluster: PUSHER_CLUSTER,
            authorizer: authorizer()
        });
        const onStateChange = ({ current })=>{
            recordMainThreadConnection(current === 'connected');
        };
        pusher.connection.bind('state_change', onStateChange);
        recordMainThreadConnection(pusher.connection.state === 'connected');
        subscriber.next(pusher);
        return ()=>{
            pusher.connection.unbind('state_change', onStateChange);
            recordMainThreadConnection(false);
            pusher.disconnect();
        };
    })), shareReplay(1));
export const client = ()=>pusher$;
